import script from "./MembershipCalculator.vue?vue&type=script&setup=true&lang=ts"
export * from "./MembershipCalculator.vue?vue&type=script&setup=true&lang=ts"

import "./MembershipCalculator.vue?vue&type=style&index=0&id=2ce797ea&scoped=true&lang=css"

import exportComponent from "/Users/jgividen/Documents/louder/repos/sync/ptpn-website/wp-content/plugins/bb-custom-module-examples/assets/js/component-lib/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce797ea"]])

export default __exports__